import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BusinessService",
  controller: "Banks",
};

const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "GetItemById",
  "FindByConditions",
  "FindAll",
  "GetPageContentByConditions"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const BankApi = ZJApi.defineNewApi("BankApi", factory);

export default BankApi;
